import { render, staticRenderFns } from "./ModalCustomerReport.vue?vue&type=template&id=35bfacd2"
import script from "./ModalCustomerReport.vue?vue&type=script&lang=js"
export * from "./ModalCustomerReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports